
export const environment = {
    APP_TYPE: process.env.REACT_APP_TYPE,
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    APP_BUSINESS_URL: process.env.REACT_APP_BUSINESS_URL,
    APP_IS_MOBILE: process.env.REACT_APP_IS_MOBILE !== undefined ? process.env.REACT_APP_IS_MOBILE === 'true' : false,
    DEFAULT_RESERVEAT_TOKEN_ID: process.env.REACT_APP_DEFAULT_RESERVEAT_TOKEN_ID !== undefined ? process.env.REACT_APP_DEFAULT_RESERVEAT_TOKEN_ID : '1'

}